const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`;
const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<style>
.bugs {
  /*
  CSS variables should be defined in the generated CSS file
  For now set any missing variables below within "bugs",
   then use the variables below
  */
  --wa-spacing-s: 12;
  --wa-shadow-offset-y-m: 4;
  --wa-color-neutral-100: #ffffff;
  --wa-spacing-l: 24px;
  --wa-font-size-s: 14px;
  --wa-font-weight-semibold: 500;
  --wa-line-height-normal: 1.2;
  --wa-color-neutral-30: #3f3f46;
  /* --wa-spacing-l: 24px; duplicate */
  /* --wa-color-neutral-30: #403d3d; duplicate */
  --wa-color-neutral-40: #52525b;
  /* --wa-font-size-s: 14px; duplicate */
  /* --wa-font-weight-semibold: 500; duplicate */
  /* --wa-line-height-normal: 1.2;duplicate */
  --wa-color-primary-50: #3b82f6;
  --wa-color-neutral-40: #3b82f6;
  /* duplicate --wa-font-weight-semibold: 500; */
}
/* define CSS Variables above */
/* use CSS Variables below */

.ascend-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid var(--wa-panel-border-color, #E5E5E5);
  background: var(--wa-color-neutral-100, #FFF);
  box-shadow: var(--wa-shadow-offset-x-s, 0) var(--wa-shadow-offset-y-s, 2px) var(--wa-shadow-blur-s, 2px) var(--wa-shadow-spread-s, -1px) var(--wa-shadow-small, rgba(113, 113, 122, 0.12));
}
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: var(--ts-width-content-max, 1440px);
  padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  align-self: stretch;
}

.tab-header {
  max-width: var(----ts-width-content-max, 1440px);
  padding: 0 var(--wa-spacing-l, 24px);
  align-items: center;
  align-self: stretch;
}

.a {
  border-bottom: none;
}
.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Hamburger Button */
.hamburger {
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger span {
  height: 3px;
  width: 100%;
  background-color: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Mobile Nav Menu */
.mobile-nav {
  display: none;
  transition: max-height 0.3s ease;
}

/* dynamic Toggle class */
.ascend-header-level1.menu-open .mobile-nav {
  display: flex;
}

.header-margin-class {
  margin: var(--wa-spacing-l) 24px 12px 12px 24px;
}




.profile-menu {
  display: flex;
  align-items: center;
}

.profile-dropdown {
  position: relative;
  display: flex;
  align-items: center;
}



.profile-label {
  display: block;
  text-overflow: ellipsis; 
}

.header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-wrap: nowrap;
}
  



.group-icon {
  display: flex;
  align-items: center;
}

.bell-icon {
}

.nav-horizontal {
  display: flex;
  gap: 1rem;
}

div img {
  width: 160px;
  height: 40px;
}


.mobile-menu-link {
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease;
}
.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-menu {
  min-width: 140px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  /* padding: 0.5rem 0; */
  display: block;
  position: absolute;
  z-index: 200;
}
.dropdown-item {
  padding: 0.25rem 1rem;
  color: #212529;
  list-style: none;
  font-size: 16px;
  text-decoration: none;
}
.dropdown-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.mobile-profile-menu {
  display: none;
}


@media only screen and (min-width: 320px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);
  }
  
}

@media only screen and (max-width: 576px) {
  
  .ascend-header {
    /* mobile overrides */
  }
  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);  
  }
  
  .utility-btn::part(base) {
    height: 30px;
  }
  .utility-btn::part(label),
  .profile-btn::part(label) {
    padding: 0 var(--wa-spacing-3xs, 2px);
    
  }
  .profile-btn::part(base) {
    display: flex;
    width: 20px;
    height: 20px;
    padding: var(--wa-spacing-3xs, 2px);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }
  .profile-btn::part(label) {
    display: none;
  }
  .profile-btn::part(caret) {
    display: none;
  }
  .profile-icon::part(svg) {
    width: var(--wa-spacing-m, 16px);
    height: var(--wa-spacing-m, 16px);
    flex-shrink: 0;
    fill: #404040;
  }
  .ham-btn {
    display: flex;
    width: var(--wa-spacing-l, 24px);
    height: var(--wa-spacing-l, 24px);
    padding: var(--wa-spacing-3xs, 2px);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;  
  }
  .container-fluid {
    display: flex;
    max-width: 375px;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    padding: 0;
  }
  .nav-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
  }
  .nav-item {
    display: flex;
    width: 343px;
    height: var(--wa-spacing-2xl, 40px);
    padding: 0 var(--wa-spacing-m, 16px);
    align-items: center;
    gap: var(--wa-spacing-s, 12px);
    align-self: stretch;
  }
  .nav-divider {
    display: flex;
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-m, 16px);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
  }
  
  .divider-line {
    width: 343px;
    height: var(--wa-border-width-s, 1px);
    background: #D9D9D9;
    align-self: stretch;
  }
  .menu-btn::part(base) {
    display: flex;
    padding: var(--wa-spacing-2xs, 4px) 18px var(--wa-spacing-2xs, 4px) var(--wa-spacing-m, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

}

@media only screen and (min-width: 768px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
  
}

@media only screen and (min-width: 992px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

@media only screen and (min-width: 1200px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

@media only screen and (min-width: 1440px) {
  .ascend-header {
    max-width: 1400px;
    margin: 0 auto;
  }

  .main-nav {
    padding: var(--wa-spacing-s, 12px) var(--wa-spacing-l, 24px);
  }
}

.open {
  display: block;
}

.closed {
  display: none;
}
</style>
`
const TemplateNavHeaderStyles = t
export { TemplateNavHeaderStyles }
